module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Electric/Iron-0f20b191b933b937f89793499e66ac4b.svg";